import User from '../types/User';
import * as types from '../actions/actionTypes';
import { ActionPayloadType } from '../types/ActionPayloadType'

const initialUserListState: User[] = [];

export default function userListReducer(state = initialUserListState, action: ActionPayloadType): User[] {
  switch (action.type) {
    case types.LOAD_USERS_SUCCESS:
      return action.userList ?? [];
    
    case types.ADD_USER_SUCCESS:
        if (action.user) {
        return [...state, action.user ];
        }
        return state;
    
    case types.DELETE_USER_SUCCESS:
            if (action.id !== undefined) {
            return state.filter(user => user.id !== action.id);
            }
    
    default:
      return state;
  }
}
